<template>
  <div>
    <div v-if="props.type === 'image'">
      <Carousel v-if="props.imageUrls && props.imageUrls.length > 1" :images="props.imageUrls" />
      <div v-else-if="props.imageUrl" class="w-full">
        <img
          class="h-full w-full select-none object-cover"
          v-lazy="{
            src: renderImage(props.imageUrl, 1000),
            loading: renderImage(props.imageUrl, 10),
          }"
          :alt="title"
        />
      </div>
    </div>

    <div v-else-if="props.type === 'video'" class="bg-black">
      <VideoPlayerMux
        v-if="playbackData?.playbackId"
        ref="videoPlayerRef"
        :id="id"
        :playback-id="playbackData.playbackId"
        :token="playbackData.token"
        :thumbnail-token="playbackData?.thumbnailToken"
        :jwt="playbackData.jwt"
        :title="title"
        :is-active="isActive"
      />
      <div v-else class="aspect-video"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

import { renderImage } from '@helpers/cloudinary';
import { useMuxMediaFetcher } from '@api/content.api';

import Carousel from '@modules/Carousel.vue';
import VideoPlayerMux from '@modules/VideoPlayer/VideoPlayerMux.vue';
import { useAccountStore } from '@stores/account.store';

interface MediaProps {
  id: string;
  type?: 'image' | 'video';
  title: string;
  imageUrl?: string;
  imageUrls?: string[];
  fullscreenAllowed?: boolean;
  isActive?: boolean;
}

interface PlaybackData {
  playbackId: string;
  token: string;
  jwt: string;
  thumbnailToken?: string;
}
const props = defineProps<MediaProps>();
const playbackData = ref<PlaybackData>();
const accountStore = useAccountStore();
const videoPlayerRef = ref<InstanceType<typeof VideoPlayerMux> | null>(null);

const toggleFullscreen = () => {
  if (videoPlayerRef.value) {
    videoPlayerRef.value.toggleFullscreen();
  }
};

onMounted(async () => {
  // move into VideoPlayerMux.vue
  if (props.type === 'video') {
    const contentPlayFetcher = useMuxMediaFetcher();
    await contentPlayFetcher.execute({ id: props.id, thumbnailTime: 0 }, accountStore.authToken);
    playbackData.value = contentPlayFetcher.data.value;
  }
});

defineExpose({
  toggleFullscreen,
});
</script>
